import { useEffect, useRef } from 'react';
import { LiveFeedAdapter } from '../adapters';
import { useMapperPluginConfig } from '../mapperConfig';
import { useMapStore } from '../MapContext';

interface LiveObjectsLayerProps {
  linkedDeviceIds: string[];
}

/** L4 — poll telemetry-read; pause when tab hidden. */
export default function LiveObjectsLayer({ linkedDeviceIds }: LiveObjectsLayerProps) {
  const { data: configData } = useMapperPluginConfig();
  const liveConfig = configData?.config?.layers?.live;
  const setLivePositions = useMapStore((s) => s.setLivePositions);
  const pausedRef = useRef(false);

  useEffect(() => {
    if (!liveConfig?.enabled || linkedDeviceIds.length === 0) return;
    const pollMs = liveConfig.poll_interval_ms || 15000;

    const poll = async () => {
      const rows = await LiveFeedAdapter.latest(linkedDeviceIds);
      const positions = (rows || []).flatMap((r: { events?: Array<{ deviceId: string; lat?: number; lng?: number }> }) =>
        (r.events || []).map((e) => ({ deviceId: e.deviceId, lat: e.lat, lng: e.lng })),
      );
      setLivePositions(positions.filter((p) => p.lat != null && p.lng != null));
    };

    poll();
    const unsub = LiveFeedAdapter.subscribe(pollMs, poll, () => pausedRef.current);
    const onVis = () => {
      pausedRef.current = document.hidden;
    };
    document.addEventListener('visibilitychange', onVis);
    return () => {
      unsub();
      document.removeEventListener('visibilitychange', onVis);
    };
  }, [liveConfig?.enabled, liveConfig?.poll_interval_ms, linkedDeviceIds, setLivePositions]);

  return null;
}
